import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/apiService';
import { queryKeys } from '../config/queryClient';
import {
  DashboardLayout,
  DashboardLayoutResponse,
  DEFAULT_DASHBOARD_LAYOUT,
  isDashboardWidgetId,
} from '../config/dashboardWidgets/types';

const toDashboardLayout = (response: DashboardLayoutResponse): DashboardLayout => {
  const widgets = response.widgets.filter((widget) => isDashboardWidgetId(widget.id));

  if (widgets.length === 0) {
    return DEFAULT_DASHBOARD_LAYOUT;
  }

  return {
    columnCount: response.columnCount === 1 ? 1 : 2,
    widgets,
  };
};

export const useDashboardLayout = () => {
  const query = useQuery({
    queryKey: queryKeys.dashboard.layout(),
    queryFn: () => apiService.getDashboardLayout(),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: true,
  });

  const layout = useMemo((): DashboardLayout => {
    if (query.isSuccess && query.data) {
      return toDashboardLayout(query.data);
    }
    return DEFAULT_DASHBOARD_LAYOUT;
  }, [query.isSuccess, query.data]);

  return {
    ...query,
    layout,
    layoutReady: query.isSuccess || query.isError,
  };
};
